import React, {
  createContext,
  Dispatch,
  useContext,
  useMemo,
  useState
} from "react"
import { initialState } from "./config"

export interface TooltipContext {
  data: any[]
  coords: {
    x: number
    y: number
  }
  containerSize: {
    widthStartsAt: number
    width: number
    height: number
  }
  setToolTipData: Dispatch<Omit<TooltipContext, "setToolTipData">>
}

const initailContext: TooltipContext = {
  ...initialState,
  setToolTipData: () => null
}

// Context
export const TooltipContext = createContext<TooltipContext>(initailContext)

// Hook
export function useTooltipContext(): TooltipContext {
  return useContext<TooltipContext>(TooltipContext)
}

// Provider
export default function TooltipProvider({
  children
}: {
  children: React.ReactNode
}) {
  const [data, setToolTipData] = useState<
    Omit<TooltipContext, "setToolTipData">
  >({ ...initialState })

  const providerValue = useMemo(() => {
    return {
      ...data,
      setToolTipData
    }
  }, [data])

  return (
    <TooltipContext.Provider value={providerValue}>
      {children}
    </TooltipContext.Provider>
  )
}
